import React from 'react';

interface SharedReadOnlyBannerProps {
  className?: string;
}

const SharedReadOnlyBanner: React.FC<SharedReadOnlyBannerProps> = ({ className = '' }) => {
  return (
    <div className={`rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-amber-900 ${className}`.trim()}>
      <p className="font-semibold">Read-only shared access</p>
      <p className="text-sm">
        You can review this submission, download documents, and complete payment, but only the submission owner can make edits.
      </p>
    </div>
  );
};

export default SharedReadOnlyBanner;
